<div class="avatar_box aspect-ratio_1-1 d-flex align-items-center justify-content-center font-trueno-bold text-uppercase bgcover"
     [style.background-color]="color"
     [style.background-image]="'url(' + avatarUrl + ')'"
     [ngClass]="[textColor, size]">
  {{displayedLetters}}
</div>
